import './Templates.scss'
import { useNavigate, useSearchParams } from 'react-router-dom'
import React from 'react'
import { TemplateLookup } from '../../../models/TemplateLibrary'
import { TEMPLATE_TABS, TEMPLATE_TYPES } from './TemplatesTab'
import { ClickNavigation } from '../../../components/NavigationWithSideBar/ClickNavigation'
import { TemplatesTabView } from './TemplatesTabView'
import { Button } from '../../../components/Button/Button'

export const Templates = () => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const activeCategoryId = searchParams.get('category') ?? TEMPLATE_TABS[0].key

  const onClick: (templateLookup: TemplateLookup) => void = (templateLookup) => {
    navigate(`/workspace/setup/templates/template/${templateLookup.id}`)
  }

  const handleSectionClick = (id: string) => {
    setSearchParams({ category: id }, { replace: true })
  }

  const sections = TEMPLATE_TABS.map((tab) => ({
    id: tab.key,
    label: <span className={'searchParams' in tab ? 'template-tab' : 'template-group'}>{tab.label}</span>,
    title: 'header' in tab ? tab.header : tab.label,
    disabled: !('searchParams' in tab),
    content: () => ('searchParams' in tab ? <TemplatesTabView templatesTab={tab} onClick={onClick} /> : null),
  }))

  const activeTab = TEMPLATE_TYPES.find((tab) => tab.key === activeCategoryId)
  const isYourTemplatesTab = activeCategoryId === 'your-templates'
  const meetingSummaryTab = TEMPLATE_TYPES.find((tab) => tab.key === 'meeting-summary')!
  const addTemplateTab = isYourTemplatesTab ? meetingSummaryTab : activeTab

  const addTemplateButton = addTemplateTab ? (
    <Button
      variant='primary'
      className='d-flex gap-2 zocks-mb-0.75 w-100 px-0'
      onClick={() =>
        navigate('/workspace/setup/templates/template/create', {
          state: {
            templateTypeName: addTemplateTab.label,
            templateType: addTemplateTab.searchParams.type ?? '',
            templateTypeId: addTemplateTab.searchParams.typeId ?? addTemplateTab.key,
          },
        })
      }
    >
      <i className='bi bi-plus' />
      Add template
    </Button>
  ) : null

  return (
    <div className='d-flex gap-5 templates-tab-wrapper'>
      <ClickNavigation
        className='w-100'
        sections={sections}
        defaultActiveSectionId={activeCategoryId}
        activeSectionId={activeCategoryId}
        onSectionClick={handleSectionClick}
        NavigationHeader={addTemplateButton}
      />
    </div>
  )
}
